import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../images/logo/logo.png";
import { useState, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";

function Navbar() {
  const [nav, setNav] = useState(false);
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("passengerData"));
    if (storedUser) setUser(storedUser);
  }, []);

  const openNav = () => {
    setNav(!nav);
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("passengerData");
    setUser(null);
    navigate("/signin");
  };

  // Function to check if the link is active
  const isActive = (path) => (location.pathname === path ? "active" : "");

  return (
    <>
      <nav style={styles.nav}>
        {/* Mobile Navbar */}
        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`} style={styles.mobileNavbar}>
          <div onClick={openNav} className="mobile-navbar__close" style={styles.mobileClose}>
            <i className="fa-solid fa-xmark"></i>
          </div>
          <ul className="mobile-navbar__links" style={styles.mobileLinks}>
            <li><Link onClick={openNav} to="/" className={isActive("/")}>Home</Link></li>
            <li><Link onClick={openNav} to="/about" className={isActive("/about")}>About</Link></li>
            <li><Link onClick={openNav} to="/models" className={isActive("/models")}>Models</Link></li>
            <li><Link onClick={openNav} to="/testimonials" className={isActive("/testimonials")}>Testimonials</Link></li>
            <li><Link onClick={openNav} to="/team" className={isActive("/team")}>Our Team</Link></li>
            <li><Link onClick={openNav} to="/contact" className={isActive("/contact")}>Contact</Link></li>
            {!user ? (
              <>
                <li><Link onClick={openNav} to="/signin" className={isActive("/signin")}>Sign In</Link></li>
                <li><Link onClick={openNav} to="/register" className={isActive("/register")}>Register</Link></li>
              </>
            ) : (
              <li className="profile-dropdown">
                <div className="profile-icon" onClick={() => setDropdownOpen(!dropdownOpen)}>
                  <FaUserCircle size={24} />
                  <span>{user.firstName} {user.lastName}</span>
                  <i className={`fa-solid fa-chevron-down ${dropdownOpen ? "open" : ""}`}></i>
                </div>
                {dropdownOpen && (
                  <ul className="dropdown-menu">
                    <li>
                      <button className="logout-btn" onClick={logout}>Logout</button>
                    </li>
                  </ul>
                )}
              </li>
            )}
          </ul>
        </div>

        {/* Desktop Navbar */}
        <div className="navbar" style={styles.navbar}>
          <div className="navbar__img" style={styles.logoContainer}>
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src={Logo} alt="logo-img" style={styles.logo} />
            </Link>
          </div>
          <ul className="navbar__links" style={styles.navLinks}>
            <li><Link to="/" className={isActive("/")}>Home</Link></li>
            <li><Link to="/about" className={isActive("/about")}>About</Link></li>
            <li><Link to="/models" className={isActive("/models")}>Vehicles</Link></li>
            <li><Link to="/testimonials" className={isActive("/testimonials")}>Testimonials</Link></li>
            <li><Link to="/team" className={isActive("/team")}>Our Team</Link></li>
            <li><Link to="/contact" className={isActive("/contact")}>Contact</Link></li>
          </ul>

          {/* Profile or Auth Buttons */}
          <div className="navbar__buttons" style={styles.navButtons}>
            {!user ? (
              <>
                <Link to="/signin" className={`navbar__buttons__sign-in ${isActive("/signin")}`}>Sign In</Link>
                <Link to="/register" className={`navbar__buttons__register ${isActive("/register")}`}>Register</Link>
              </>
            ) : (
              <div className="profile-dropdown">
                <div className="profile-icon" onClick={() => setDropdownOpen(!dropdownOpen)}>
                  <FaUserCircle size={24} />
                  <span>{user.firstName} {user.lastName}</span>
                  <i className={`fa-solid fa-chevron-down ${dropdownOpen ? "open" : ""}`}></i>
                </div>
                {dropdownOpen && (
                  <ul className="dropdown-menu">
                    <li>
                      <button className="logout-btn" onClick={logout}>Logout</button>
                    </li>
                  </ul>
                )}
              </div>
            )}
          </div>

          {/* Mobile Menu Toggle */}
          <div className="mobile-hamb" onClick={openNav} style={styles.mobileHamb}>
            <i className="fa-solid fa-bars"></i>
          </div>
        </div>
      </nav>

      <style>
        {`
        /* Profile Dropdown */
        .profile-dropdown {
          position: relative;
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .profile-icon {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .dropdown-menu {
          position: absolute;
          top: 100%;
          right: 0;
          background: white;
          border-radius: 5px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
          padding: 8px 0;
        }

        .dropdown-menu li {
          padding: 8px 16px;
          cursor: pointer;
        }

        .dropdown-menu li:hover {
          background: #f4f4f4;
        }

        /* Styled Logout Button */
        .logout-btn {
          display: block;
          width: 100%;
          background-color: #dc3545;
          color: white;
          padding: 8px;
          font-size: 16px;
          font-weight: bold;
          border: none;
          cursor: pointer;
          text-align: center;
          border-radius: 5px;
          transition: background 0.3s ease;
        }

        .logout-btn:hover {
          background-color: #c82333;
        }
        `}
      </style>
    </>
  );
}

const styles = {
  nav: {
    width: "100%",
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1000",
  },
  navbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px 50px",
  },
  logoContainer: {
    flexShrink: "0",
  },
  logo: {
    height: "50px",
  },
  navLinks: {
    display: "flex",
    listStyle: "none",
    gap: "20px",
  },
  navButtons: {
    display: "flex",
    gap: "15px",
  },
  mobileNavbar: {
    display: "none",
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100vh",
    backgroundColor: "#fff",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1001",
  },
  mobileClose: {
    position: "absolute",
    top: "20px",
    right: "20px",
    fontSize: "24px",
    cursor: "pointer",
  },
  mobileLinks: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    listStyle: "none",
  },
  mobileHamb: {
    display: "none",
    fontSize: "24px",
    cursor: "pointer",
  },
};

/* 📱 Responsive Design */
styles.navbar["@media (max-width: 1024px)"] = {
  padding: "15px 30px",
};
styles.navLinks["@media (max-width: 768px)"] = {
  display: "none",
};
styles.navButtons["@media (max-width: 768px)"] = {
  display: "none",
};
styles.mobileNavbar["@media (max-width: 768px)"] = {
  display: "flex",
};
styles.mobileHamb["@media (max-width: 768px)"] = {
  display: "block",
};

export default Navbar;
